import { ButtonAlignment, ButtonColor, ButtonSize } from './Button.types';

export const BUTTON_COLORS = Object.freeze({
  [ButtonColor.Primary]: {
    background: 'bg-primary-gradient',
    text: 'text-white',
    font: 'font-light',
  },
  [ButtonColor.Secondary]: {
    background: 'bg-secondary-gradient',
    text: 'text-white',
    font: 'font-light',
  },
  [ButtonColor.Contrast]: {
    background: 'bg-white',
    text: 'text-primary-dark',
    font: 'font-bold',
  },
  [ButtonColor.Input]: {
    background: 'bg-gray-1',
    text: 'text-primary-dark',
    font: 'font-bold',
  },
  [ButtonColor.Transparent]: {
    background: 'unset',
    text: 'black',
    font: 'font-light',
  },
  [ButtonColor.Alert]: {
    background: 'bg-alert',
    text: 'text-white',
    font: 'font-light',
  },
  [ButtonColor.Excel]: {
    background: 'bg-excel',
    text: 'text-white',
    font: 'font-light',
  },
});

export const BUTTON_SIZES = Object.freeze({
  [ButtonSize.Small]: {
    size: 'btn-sm',
  },
  [ButtonSize.Medium]: {
    size: 'btn-md',
  },
  [ButtonSize.Large]: {
    size: 'btn-lg',
  },
});

export const getButtonAlignment = (alignment?: ButtonAlignment) => {
  switch (alignment) {
    case ButtonAlignment.Start:
      return 'flex-start';
    case ButtonAlignment.End:
      return 'flex-end';
    case ButtonAlignment.Center:
      return 'center';
    default:
      return 'baseline';
  }
};

// export const getButtonColors = (color: ButtonColor) => {
//   switch (color) {
//     case ButtonColor.Primary:
//       return
//   }
// }
